// buttons.js 			                             ~/js/
////////////////////////////////////////////////////////////

// Get button textContent to apply as a pseudo element
const goldButton = document.querySelectorAll('.gold-button');
const blackButton = document.querySelectorAll('.black-button');

// Gold Button
goldButton.forEach((goldButton) => {
  goldButton.dataset.before = goldButton.textContent;
});

// Black Button
blackButton.forEach((blackButton) => {
  blackButton.dataset.before = blackButton.textContent;
});

// Army Trails Mobile Map Menu Trigger
const trailsMenuTrigger = document.querySelector('.trail-mobile-menu');
const trailsMapClose = document.querySelector('.trails-map-close');
const trailsMenu = document.querySelector('.trail-sidebar');
const trailMap = document.querySelector('.trail-map #map');

if (document.body.contains(trailsMenuTrigger)) {
  trailsMenuTrigger.addEventListener('click', () => {
    trailsMenu.classList.toggle('slide-in');
    trailMap.classList.toggle('darken');
  });

  trailsMapClose.addEventListener('click', () => {
    trailsMenu.classList.toggle('slide-in');
    trailMap.classList.remove('darken');
  });
}
